<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('property.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active almarai-bold mx-3" aria-current="page">{{$t('property.breadcrumb_2')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container">
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">

        <div class="row py-2">
          <div class="col">
            <div v-if="hasError">
              <errorAlert :alertMessage="message" :errorNumber="errorNumber" />
            </div>
          </div>
        </div>
        
        <div class="row justify-content-center" v-if="rows.length && containers.length">
          <div class="col-12 col-md-5 text-center">
            <router-link  to="/propertymanagement">
              <div class="form-control btn-green">
                <i class="fa-solid fa-circle-plus mx-2"></i> {{$t('property.title_1')}}
              </div>
            </router-link>
          </div>
        </div>

        <div class="row pt-5">
          <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(row,index) in rows" :key="index">
            <router-link :to="'/propertydetails/'+row.id+'?m=1&a=1&propertyType=property'">
              <div class="card card-border m-auto">
                <div class="card-body padding-8">
                  <div class="row position-Abso pt-2">
                    <div class="col-auto tag-style">
                      <span class="">{{ row.PropertyType.name }}</span>
                    </div>
                    <div class="col-auto tag-style mx-2">
                      <span class="">{{items.statusChoices[row.status]}}</span>
                    </div>
                    <div class="col-auto tag-style">
                      <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                    </div>
                  </div>
                  <!-- <span v-if="val.Favorites && val.Favorites.length" @click.prevent="removeFavorite(row.id, 'Properties', index)" class="heart-icon">
                    <i class="fa-solid fa-heart orange-Heart"></i>
                  </span>
                  <span v-else class="heart-icon" @click.prevent="addFavorite(row.id, 'Properties', index)">
                    <i class="fa-solid fa-heart heart"></i>
                  </span> -->
                  <swiper v-if="row.mediaFiles.length" class="text-center" 
                    :modules="modules"
                    :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                    <swiper-slide v-for="(slide, indx) in row.mediaFiles" :key="indx">
                      <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                  </div>
                  <div class="almarai-regular py-1">{{ row.title }}</div>
                  <div class="d-flex">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="gray-color fonttext-14 mx-2"> {{ row.City.name }} </div>
                    <span class="gray-color fonttext-14"> {{ row.Neighborhood.name }} </span>
                  </div>
                  <hr class="border-color-w">
                  <div class="row end-card">
                    <div class="col">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F">{{ row.price }}</span>
                      <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                    </div>
                    <div v-if="row.roomsCount" class="col-auto content-center">
                      <img :src="MEDIA_URL+icons.roomsCount.path" class="max-width-28" alt="">
                      <span class="numbers"> {{ row.roomsCount }} </span>
                    </div>
                    <div v-if="row.bathrooms" class="col-auto border_Icons">
                      <img :src="MEDIA_URL+icons.bathrooms.path" class="max-width-28" alt="">
                      <span class="numbers"> {{ row.bathrooms }} </span>
                    </div>
                    <div v-if="!row.roomsCount && !row.bathrooms && row.area" class="col-auto border_Icons">
                      <img :src="MEDIA_URL+icons.area.path" class="max-width-28" alt="">
                      <span class="numbers"> {{ row.area }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <!-- begin:container-->
          <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val,index) in containers" :key="index">
            <router-link :to="'/containerRetrieve/'+val.id">
              <div class="card card-border m-auto">
                <div class="card-body padding-8">
                  <div class="row position-Abso pt-2">
                    <div class="col-auto tag-style">
                      <span class="">{{ val.PropertyContainerType.name }}</span>
                    </div>
                  </div>
                  <swiper v-if="val.PropertyContainerMedia.length" class="text-center" 
                    :modules="modules"
                    :autoplay="{ delay: 2500,disableOnInteraction: false,}" 
                    :pagination="{ clickable: true }" :navigation="false"
                  >
                    <swiper-slide v-for="(slide, indx) in val.PropertyContainerMedia" :key="indx">
                      <img :src="MEDIA_URL+slide.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                    </swiper-slide>
                  </swiper>
                  <div v-else>
                    <img src="/assets/images/defaultImage.jpg" class="w-100 br-radius" alt="">
                  </div>
                  <div class="almarai-regular py-1">{{ val.title }}</div>
                  <div class="d-flex">
                    <i class="fa-solid fa-location-dot gray-color"></i>
                    <div class="gray-color fonttext-14 mx-2"> {{ val.City.name }} </div>
                    <span class="gray-color fonttext-14"> {{ val.Neighborhood.name }} </span>
                  </div>
                  <hr class="border-color-w">

                  <div class="row space">
                    <div class="col-7 col-lg-7 button-center">
                      <div class="row">
                        <div class="col-auto">
                          <img src="/assets/images/icons/Frame-5.png" class="max-35" alt="">
                        </div>
                        <div class="col-4 col-md-6 p-0">
                          <div class="fonttext-14 gray-color">{{$t('property.rentalValue')}}</div>
                          <span class="gray-color mx-2 almarai-bold">{{ val.collectedAmount }}</span>
                          <img src="/assets/images/icons/riyal.png" class="max-12 almarai-bold" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="col-5 col-lg-5">
                      <router-link :to="'containerRetrieve/'+val.id">
                        <div class="moreKnow-btn">{{$t('myproperty.more')}}</div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <!-- end:container -->
        </div>

        <div class="row" v-if="!rows.length && !containers.length">
          <div class="col">
            <div class="row justify-content-center">
              <div class="col-12 col-md-7 text-center">
                <div class="card bg-leadGray border-0">
                  <div class="card-body">
                    <img src="/assets/images/icons/pro.png" class="width-80"  alt="">
                    <div class="almarai-bold">{{$t('property.propertyRentSale')}}</div>
                    <div class="almarai-bold pt-2 font-20 almarai-bold">{{$t('property.propertyDeserves')}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div class="col-12 col-md-7">
                <h6>{{$t('property.property_title_3')}}</h6>
                <div class="row justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_1')}}</span>
                  </div>
                </div>

                <div class="row py-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class=" mx-1 gray-50 font-12">{{$t('property.service_include_2')}}</span>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_3')}}</span>
                  </div>
                </div>

                <div class="row py-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_4')}}</span>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-24"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_5')}}</span>
                  </div>
                </div>
                <div class="row pt-2  justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_6')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_7')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_8')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_9')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_10')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/check_Icons.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_11')}}</span>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <!-- <div class="col-12 col-md-5">
                    <a href="">
                      <span>{{$t('property.contactManager')}}</span>
                      <img src="/assets/images/icons/calling.png" class="max-16" alt="">
                    </a>
                  </div> -->
                  <div class="col-12 col-md-5 text-center">
                    <router-link  to="/propertymanagement">
                      <div class="form-control btn-green">
                        <i class="fa-solid fa-circle-plus mx-2"></i> {{$t('property.title_1')}}
                      </div>
                    </router-link>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col text-center">
                    <a href="https://wa.me/+966920016962?text= السلام عليكم أود التواصل مع أخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى. شكرًا لكم" target="_blank">
                      <div class="almarai-bold">{{$t('property.btn_contactCustomer')}}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
export default {
  name: "allProperties",
  setup(){
    return{
      modules: [Autoplay, Navigation, Pagination ],
    }
  },
  data(){
    return {
      hasError: false,
      message: "",
      errorNumber: null,
      isLoading: false,
      rows: [],
      icons: {},
      items: {},
      containers: [],
      userLang: 'ar',
      purpose: "",
    }
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER'])
  },
  methods: {
    getUserProperties(){
      this.isLoading = true;
      this.hasError = false;
      this.$http.get("/api/properties/myProperties").then(res => {
        // console.log(res);
        this.rows = res.data.managedProperties;
        this.icons = res.data.countedIcons;
        this.items = res.data;
        this.containers = res.data.containers;
        this.isLoading = false;
      }).catch (err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
  },
  created(){
    this.getUserProperties();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top : 'behavior'});
  }
}
</script>